import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { LayoutModule } from "../layout/layout.module"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import {
	MatCardModule,
	MatInputModule,
	MatTableModule,
	MatButtonModule,
	MatSelectModule,
	MatExpansionModule,
	MatFormFieldModule,
	MatProgressSpinnerModule,
	MatCheckboxModule,
	MatTooltipModule,
	MatDividerModule,
	MatAutocompleteModule,
	MatDialogModule,
	MatSlideToggleModule
} from "@angular/material"
import { RouterModule } from "@angular/router"
import { NgbModule, NgbModalConfig, NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { TranslateModule } from "@ngx-translate/core"
import { Ng2PageScrollModule } from "ng2-page-scroll"
import { NgxFileDropModule } from "ngx-file-drop"
import { AuthService } from "src/app/services/auth.service"
import { BaseService } from "src/app/services/base.service"
import { MapService } from "src/app/services/map.service"
import { CatalogFtthComponent } from "../pages/catalog/catalog-ftth/catalog-ftth.component"
import { CatalogP2pComponent } from "../pages/catalog/catalog-p2p/catalog-p2p.component"
import { ModalErrorComponent } from "./modals/modal-error/modal-error.component"
import { ModalUploadFileComponent } from "./modals/modal-upload-file/modal-upload-file.component"
import { NotificationComponent } from "./notification/notification.component"
import { PointToPointInfoComponent } from "./point-to-point/point-to-point-info/point-to-point-info.component"
import { ResultModalComponent } from "./point-to-point/point-to-point-result/result.modal.component"
import { SsoHandlerComponent } from "./sso-handler/sso-handler.component"
import { ModalLegendaComponent } from "./modals/modal-legenda/modal-legenda.component"
import { SearchPlaceComponent } from "./address/search-place/search-place.component"
import { SelectPoiComponent } from "./address/select-poi/select-poi.component"
import { CivicPriceListComponent } from "./civic-price-list/civic-price-list.component"
import { GMapButtonComponent } from "./map/gmap-button/gmap-button.component"
import { GMapContainerComponent } from "./map/gmap-container/gmap-container.component"
import { GMapComponent } from "./map/gmap/gmap.component"
import { ModalMultiBuildingComponent } from "./modals/modal-multi-building/modal-multi-building.component"

@NgModule({
	declarations: [
		PointToPointInfoComponent,
		ResultModalComponent,
		CatalogP2pComponent,
		CatalogFtthComponent,
		ModalUploadFileComponent,
		NotificationComponent,
		ModalErrorComponent,
		ModalLegendaComponent,
		SsoHandlerComponent,
		SearchPlaceComponent,
		SelectPoiComponent,
		GMapComponent,
		GMapContainerComponent,
		GMapButtonComponent,
		CivicPriceListComponent,
		ModalMultiBuildingComponent
	],
	entryComponents: [ModalLegendaComponent],
	imports: [
		RouterModule,
		CommonModule,
		FormsModule,
		LayoutModule,
		MatCardModule,
		MatInputModule,
		MatTableModule,
		MatButtonModule,
		MatSelectModule,
		MatExpansionModule,
		MatSelectModule,
		Ng2PageScrollModule.forRoot(),
		NgbModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatCheckboxModule,
		TranslateModule,
		MatTooltipModule,
		MatDividerModule,
		MatAutocompleteModule,
		ReactiveFormsModule,
		NgxFileDropModule,
		MatDialogModule,
		MatSlideToggleModule
	],
	exports: [
		RouterModule,
		LayoutModule,
		FormsModule,
		PointToPointInfoComponent,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		CatalogP2pComponent,
		CatalogFtthComponent,
		NotificationComponent,
		ModalErrorComponent,
		ResultModalComponent,
		ModalUploadFileComponent,
		SsoHandlerComponent,
		CivicPriceListComponent,
		SearchPlaceComponent,
		SelectPoiComponent,
		GMapComponent,
		ModalMultiBuildingComponent
	],
	providers: [MapService, AuthService, NgbModalConfig, NgbModal, BaseService]
})
export class PartialsModule {}
